import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

/**
 * Project defaults. The anon/publishable key is safe in client code (every
 * table is protected by row-level security), and hardcoding it means the site
 * keeps working in previews or on hosts where the REACT_APP_* build variables
 * were never configured — without them the CMS content silently disappears.
 */
const fallbackUrl = "https://khqpogisooscbhyofjtc.supabase.co";
const fallbackKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtocXBvZ2lzb29zY2JoeW9manRjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ1Mzk5NDgsImV4cCI6MjEwMDExNTk0OH0.Dvo9LsTlGt6hFy2Fef8YO-9vZkdIylrUjXGXzbPGw60";

const REMEMBER_PREFERENCE_KEY = "zetech-admin-remember";

function browserStorage() {
  if (typeof window === "undefined") return null;
  return {
    local: window.localStorage,
    session: window.sessionStorage,
  };
}

function shouldRememberSession() {
  const storage = browserStorage();
  // Preserve the prior persistent-session behaviour until a user makes a
  // choice on the login page.
  return storage?.local.getItem(REMEMBER_PREFERENCE_KEY) !== "false";
}

const adminAuthStorage = {
  getItem(key) {
    const storage = browserStorage();
    if (!storage) return null;
    return (shouldRememberSession() ? storage.local : storage.session).getItem(key);
  },
  setItem(key, value) {
    const storage = browserStorage();
    if (!storage) return;
    const target = shouldRememberSession() ? storage.local : storage.session;
    const other = shouldRememberSession() ? storage.session : storage.local;
    target.setItem(key, value);
    other.removeItem(key);
  },
  removeItem(key) {
    const storage = browserStorage();
    storage?.local.removeItem(key);
    storage?.session.removeItem(key);
  },
};

/** Select whether the next CMS session survives a browser restart. */
export function setAdminSessionPersistence(remember) {
  const storage = browserStorage();
  if (!storage) return;
  storage.local.setItem(REMEMBER_PREFERENCE_KEY, remember ? "true" : "false");
}

export const supabase = createClient(url || fallbackUrl, key || fallbackKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: adminAuthStorage,
    storageKey: "zetech-admin-auth",
  },
});
